import { defaultConfig, DynamicConfig } from '@/config/config';
import { createContext } from 'react';

export type DynamicConfigContext = {
  config: DynamicConfig;
  setConfig: (newConfig: DynamicConfig) => void;
  serverInfo?: string;
  setServerInfo: (newInfo: string) => void;
};

export const ConfigContext = createContext<DynamicConfigContext>({
  config: defaultConfig,
  setConfig: () => {},
  setServerInfo: () => {}
});
